import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'material-ui/styles/withStyles';
import Tiles from '../../../components/main/files/tiles/index';
import styles from './styles';

const FilesPage = props => {
	const {
		collection,
		collectionId,
		handleOpenFile,
		classes
	} = props;

	const tilesProps = {handleOpenFile, collectionId};

	return (
		<React.Fragment>
			<div className={classes.description}>
				{collection.description}
			</div>
			<Tiles {...tilesProps}/>
		</React.Fragment>
	);
};

FilesPage.propTypes = {
	classes: PropTypes.object.isRequired,
	collection: PropTypes.object.isRequired,
	collectionId: PropTypes.string.isRequired,
	handleOpenFile: PropTypes.func.isRequired
};

export default withStyles(styles)(FilesPage);



// WEBPACK FOOTER //
// ./src/client/pages/main/files/files.jsx